import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: {},
  sms: {},
  whatsapp: {},
};

export const campaignSlice = createSlice({
  name: 'campaign',
  initialState,
  reducers: {
    saveEmailData: (state, { payload }) => {
      state.email = { ...state.email, ...payload };
    },
    clearEmailData: () => ({ ...initialState, email: {} }),
    clearCampaigns: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const { saveEmailData, clearCampaigns, clearEmailData } = campaignSlice.actions;

export default campaignSlice.reducer;
